import { useMemo } from 'react';
import { useCartItemsPresentation } from './useCartItemsPresentation';
import { useCartSummaryPresentation } from './useCartSummaryPresentation';

export const useCartPresentationSlices = ({
  dispatch,
  actions,
  support,
  stateRef
}) => {
  const summary = useCartSummaryPresentation({
    dispatch,
    actions,
    addToast: support.addToast
  });

  // The items slice reads two things from the summary side: the cart id already
  // in state (via `stateRef`, so a mutation can refresh the right cart without
  // the caller passing an id), and `getCart` for the one case where there is no
  // id yet — the first add, which is what creates the cart.
  const items = useCartItemsPresentation({
    dispatch,
    actions,
    addToast: support.addToast,
    setLoading: support.setLoading,
    stateRef,
    getCart: summary.getCart
  });

  return useMemo(() => ({ summary, items }), [summary, items]);
};
